import React from "react";

const ModalCloseIcon = (props) => {
	return (
		<svg
			width="32"
			height="32"
			viewBox="0 0 32 32"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...props}>
			<rect
				x="0.5"
				y="0.5"
				width="31"
				height="31"
				rx="15.5"
				stroke="#A0A3BD"
			/>
			<path
				d="M11 11L21.6452 21.6452"
				stroke="#A0A3BD"
				stroke-linecap="round"
				stroke-linejoin="round"
			/>
			<path
				d="M11 21.6445L21.6452 10.9994"
				stroke="#A0A3BD"
				stroke-linecap="round"
				stroke-linejoin="round"
			/>
		</svg>
	);
};

export default ModalCloseIcon;
